import { useTranslation } from 'react-i18next';

export default function Blog() {
  const { t } = useTranslation();

  const posts = [
    {
      title: t('blog.post1.title'),
      excerpt: t('blog.post1.excerpt'),
      category: t('blog.category.tax'),
      date: t('blog.post1.date'),
      image: 'https://public.readdy.ai/ai/img_res/c1eda855fc7c17d97f7e3d180aa5b6a2.jpg'
    },
    {
      title: t('blog.post2.title'),
      excerpt: t('blog.post2.excerpt'),
      category: t('blog.category.patronage'),
      date: t('blog.post2.date'),
      image: 'https://readdy.ai/api/search-image?query=Cooperative%20business%20dividend%20distribution%20documents%20with%20patronage%20calculation%20charts%2C%20professional%20financial%20planning%20materials%20with%20teal%20color%20scheme%2C%20organized%20business%20paperwork%2C%20trust%20and%20transparency%20theme&width=600&height=400&seq=blog-patronage-002&orientation=landscape'
    },
    {
      title: t('blog.post3.title'),
      excerpt: t('blog.post3.excerpt'),
      category: t('blog.category.business'),
      date: t('blog.post3.date'),
      image: 'https://readdy.ai/api/search-image?query=Small%20business%20tax%20deduction%20checklist%20with%20receipts%20and%20expense%20reports%20on%20desk%2C%20professional%20accounting%20workspace%20with%20teal%20accents%2C%20organized%20financial%20documents%2C%20business%20savings%20theme%2C%20clean%20modern%20aesthetic&width=600&height=400&seq=blog-deductions-003&orientation=landscape'
    }
  ];

  return (
    <section id="blog" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">{t('blog.title')}</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            {t('blog.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {posts.map((post, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 hover:scale-105 cursor-pointer group"
            >
              <div className="relative h-56 overflow-hidden">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                />
              </div>
              
              <div className="p-6">
                <span className="inline-block bg-orange-100 text-orange-600 text-xs font-bold px-3 py-1 rounded-full mb-3 whitespace-nowrap">
                  {post.category}
                </span>
                
                <h3 className="text-xl font-bold text-gray-900 mb-3 leading-tight line-clamp-2 group-hover:text-orange-500 transition-colors">
                  {post.title}
                </h3>
                
                <p className="text-gray-600 text-sm mb-4 line-clamp-3">
                  {post.excerpt}
                </p>
                
                <div className="flex items-center justify-between">
                  <div className="text-gray-500 text-xs">{post.date}</div>
                  <button className="flex items-center gap-2 text-orange-500 font-semibold text-sm group-hover:gap-3 transition-all whitespace-nowrap">
                    {t('blog.readMore')}
                    <i className="ri-arrow-right-line"></i>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
